import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import EnhancedOnboarding from "./pages/EnhancedOnboarding";
import GrowerDashboard from "./pages/GrowerDashboard";
import AdminPanel from "./pages/Adminpanel";
import Login from "./pages/Login";
import Profile from "./pages/Profile";
import Navbar from "./components/Navbar";
import BottomTabBar from "./components/BottomTabBar";
import NotFound from "./pages/NotFound";
import SessionGuard from "./components/SessionGuard";
import "./index.css";

// GrowerDashboard and Profile have their own in-app nav (sidebar / bottom tab
// bar + logout). The public marketing Navbar (Sign In, About, Get Started...)
// doesn't belong on top of those — it was rendering on every route before,
// including logged-in ones. Admin gets its own chrome too, so it's excluded
// here as well.
const NO_PUBLIC_NAV_PREFIXES = ["/dashboard", "/profile", "/admin"];

function AppShell() {
  const location = useLocation();
  const hideNavbar = NO_PUBLIC_NAV_PREFIXES.some(p => location.pathname.startsWith(p));

  return (
    <>
      {/* Navbar (desktop) and BottomTabBar (mobile) are the same public nav —
          only one is visible at a time via the 768px breakpoint classes on
          each (see index.css). Both hidden on dashboard/profile/admin. */}
      {!hideNavbar && <Navbar />}
      <Routes>
        <Route path="/"            element={<Home />} />
        <Route path="/about"       element={<About />} />
        <Route path="/contact"     element={<Contact />} />
        <Route path="/get-started" element={<EnhancedOnboarding />} />
        <Route path="/dashboard"   element={<SessionGuard><GrowerDashboard /></SessionGuard>} />
        <Route path="/profile"     element={<SessionGuard><Profile /></SessionGuard>} />
        <Route path="/login"       element={<Login />} />
        <Route path="/admin"       element={<AdminPanel />} />
        <Route path="*"            element={<NotFound />} />
      </Routes>
      {!hideNavbar && <BottomTabBar />}
    </>
  );
}

function App() {
  return (
    <Router>
      <AppShell />
    </Router>
  );
}

export default App;